import { fetchAll } from '@/api/statusostests'

const state = {
  all: [],
  isLoading: false
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const statusostests = await fetchAll()
      commit('setAll', statusostests)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
  },

  setAll (state, statusostests) {
    state.all = statusostests
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
